const SecondsInDay = 86400;
const SecondsInHour = 3600;

export function convertDurationToSeconds(value: { days: number; hours: number; minutes: number }) {
  const days = value.days * SecondsInDay;
  const hours = value.hours * SecondsInHour;
  const minutes = value.minutes * 60;
  return days + hours + minutes;
}

export function convertSecondsToDuration(seconds: number) {
  const days = Math.floor(seconds / SecondsInDay);
  const hours = Math.floor((seconds % SecondsInDay) / SecondsInHour);
  const minutes = Math.floor((seconds % SecondsInHour) / 60);
  return { days, hours, minutes };
}

export function convertSecondsToHoursAndMinutes(seconds: number) {
  const hours = Math.floor(seconds / SecondsInHour);
  const minutes = Math.floor((seconds % SecondsInHour) / 60);
  return { days: 0, hours, minutes };
}
